import React from "react";

import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";

import SweetAlert2 from "react-sweetalert2";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import Header from "components/Headers/Header.js";

import Api from "shared/resources/Api";
import { sectors, neighborhood } from "shared/services/PlacesService";
import InputNumber from "react-input-just-numbers";


import ReactExport from "react-data-export";
import ExcelFile from "../../shared/ExcelPlugin/components/ExcelFile"

// const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



export default class PoolList extends React.Component {
  /* Dados Grid */
  columns = [
    {
      name: "Código",
      maxWidth: "50px",
      selector: "id",
    },
    {
      name: "Nome Imóvel",
      selector: "nome",
    },
    {
      name: "Logradouro",
      selector: "logradouro",
    },
    {
      name: "Bairro",
      selector: "Bairro",
      cell: (row) => (
        <div>
          {row.bairro !== undefined && row.bairro !== null
            ? row.bairro
            : "-"}
        </div>
      ),
    },

    {
      name: "Setor",
      selector: "Setor",
      cell: (row) => (
        <div>
          {row.setor_nome !== undefined && row.setor_nome !== null
            ? row.setor_nome
            : "-"}
        </div>
      ),
    },

 
    {
      name: "Volume",
      selector: "volume",
      cell: (row) => (
        <div>
          {row.volume !== undefined && row.volume !== null
            ? row.volume
            : "-"}
        </div>
      ),
    },
    {
      name: "Tratamento Biológico",
      selector: "tratamento",
      sortable: true,
      cell: (row) => <div>{row.tratamento ? "Sim" : "Não"}</div>,
      wrap: true
    },
    {
      name: "",
      center: true,
      cell: (row) => (
        <div>
          <Button
            type="button"
            className="btn-acao "
            title="Editar"
            onClick={() => {
              this.props.history.push("/admin/pool-edit", {
                pool: row,
              });
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
          </Button>
          {localStorage.getItem("perm") !== "agente" && (
            <Button
              type="button"
              className="btn-acao "
              title="Remover"
              onClick={() => {
                this.handleDelete(row);
              }}
            >
              <FontAwesomeIcon icon={faTrashAlt} className="remove" />
            </Button>
          )}
        </div>
      ),
    },
  ];
  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };
  customStyles = {
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      response: "",
      nome: "",
      logradouro: "",
      tel: "",
      api: Api.baseURL,
      id: "",
      requesting: false,
      neighborhood: [],
      sectors: [],
      bairro: "",
      selectedSector: null,
      selectedNeighborhood: null,
      volume_min: "",
      volume_max: "",
      tratamento: "",
      complemento: "",
      numero: "",
      setor: "",
    };
  }
  componentWillMount() {

    localStorage.setItem("excel", "Reservatórios");


    document.addEventListener("keydown", (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.handleSubmit(event);
      }
    });

    if (localStorage.getItem("gridpool")) {

      var obj = JSON.parse(localStorage.getItem("gridpool"));
      this.setState({
        response: obj,
      })
    }



    neighborhood().then((res) => {
      if (res) {
        this.setState({
          neighborhood: res,
        });
      }
    });

    sectors().then((res) => {
      if (res) {
        this.setState({
          sectors: res,
        });
      }
    });
  }

  fetchSectors = async () => {
    const response = await fetch(Api.baseURL + "/setor", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        sectors: body,
      });
    }

    return body;
  };

  fetchNeighborhood = async () => {
    const response = await fetch(Api.baseURL + "/bairro", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        neighborhood: body,
      });
    }

    return body;
  };



  handleSubmit = (event) => {

    if (this.state.volume_min !== "" && this.state.volume_max !== "") {
      if (this.state.volume_min > this.state.volume_max) {
        this.setState({
          swal: {
            show: true,
            title: "Atenção",
            text: "Volume mínimo maior que o Volume máximo",
            type: "error",
          },
        });
        return false;
      }
    }

    this.setState({ response: "", requesting: true });
    this.fetchPool()
      .then((res) => this.setState({ response: res }, () => {
        localStorage.setItem("gridpool", JSON.stringify(res));
      }))
      .catch((err) => {
        console.log(err);
        this.setState({
          swal: {
            show: true,
            title: "Atenção",
            text:
              "Não foram encontradas piscinas para os parâmetros informados.",
            type: "error",
          },
          requesting: false,
        });
      });


    event.preventDefault();
  };

  fetchPool = async () => {
    let host = this.state.api + "/piscinas?";

    let params = {
      nome: this.state.nome,
      logradouro: this.state.logradouro.trim(),
      id: this.state.id,
      bairro: this.state.bairro,
      setor: this.state.setor,
      volume_min: this.state.volume_min,
      volume_max: this.state.volume_max,
      tratamento: this.state.tratamento,
      numero: this.state.numero,
      complemento: this.state.complemento,
      cod_setor:
        this.state.selectedSector !== null ? this.state.selectedSector : "",
    };
    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    const response = await fetch(host + query, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (body.length > 0) {
      this.setState({
        agent: body,
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text:
            "Não foram encontradas piscinas para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }
    return body;
  };
  handleDelete = (element) => {
    this.setState({
      swal: {
        show: true,
        title: "Atenção",
        text: "Deseja realizar a exclusão deste registro?",
        type: "error",
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: "Cancelar",
      },
      trieshop: element,
      isConfirmation: true,
    });
  };
  handleDeletePool(d) {
    this.callDel(d)
      .then()
      .catch((err) => console.log(err));
  }

  handleSetor(event) {
    this.setState({ setor: event.target.value }, () =>
      console.log(this.state.setor)
    );
  }

  callDel = async (d) => {
    const response = await fetch(Api.baseURL + "/piscinas/" + d.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        swal: {
          show: true,
          title: "Tudo Certo",
          text: "Piscina deletada com sucesso!",
          type: "success",
        },
        response: "",
        nome: "",
        logradouro: "",
        bairro: "",
        volume_min: "",
        setor:"",
        volume_max: "",
        tratamento: "",
        numero: "",
        complemento: "",
        id: ""
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Erro ao deletar piscina.",
          type: "error",
        },
      });

      throw Error(body.message);
    }

    return body;
  };

  render() {
    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });

            if (this.state.isConfirmation && !result.dismiss) {
              this.setState({
                isConfirmation: false,
              });
              this.handleDeletePool(this.state.trieshop);
            }
          }}
        />

        <Header />
        {/* Page content */}
        <Container className="mb-7 mt-5 " fluid>
        <Row className="text-right" style={{ paddingBottom:"2%" }}>
                          <Col className="order-xl-1" xl="12">
                          {localStorage.getItem("perm") !== "agente" && (
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="button"
                              onClick={() => {
                                this.props.history.push("/admin/pool-edit");
                              }}
                            >
                              <b>Cadastrar</b><i className="fa fa-arrow-right" aria-hidden="true"></i>
                            </Button>
                           
                          )}
                           </Col>
                            </Row>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Consulta de Reservatórios
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Código
                            </label>
                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-id"
                              inputMode="numeric"
                              maxLength="12"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 6);
                              }}
                              placeholder=""
                              value={this.state.id}
                              onChange={(e) =>
                                this.setState({ id: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="9">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Nome Imóvel
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-nome"
                              type="text"
                              maxLength="30"
                              required
                              value={this.state.nome}
                              onChange={(e) =>
                                this.setState({ nome: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        {/* <Col lg="3">
                          <FormGroup>
                            {this.state.sectors.length > 0 && (
                              <div>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-dtnascimento"
                                >
                                  Setor
                                </label>

                                <select
                                  value={this.state.selectedSector}
                                  onChange={(e) =>
                                    this.setState({
                                      selectedSector: e.target.value,
                                    })
                                  }
                                  className="form-control "
                                >
                                  <option defaultValue="" value="">
                                    {" "}
                                    Selecione...{" "}
                                  </option>
                                  {this.state.sectors.map((team) => (
                                    <option
                                      key={team.id}
                                      value={team.id}
                                      defaultValue={this.state.selectedSector}
                                    >
                                      {team.nome}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                         */}
                      </Row>
                      <Row>
                      <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Região
                            </label>

                            <select
                              value={this.state.setor}
                              onChange={(e) => {
                                this.handleSetor(e);
                              }}
                              className="form-control "
                              id="select-tipo"
                            >
                              <option value="">selecione...</option>
                              <option value="CENTRAL">CENTRAL</option>
                              <option value="LESTE">LESTE</option>
                              <option value="NORTE">NORTE</option>
                              <option value="OESTE">OESTE</option>
                              <option value="SUL">SUL</option>
                              
                            </select>
                          </FormGroup>
                        </Col>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-bairro"
                            >
                              Localidade
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="30"
                              value={this.state.bairro}
                              onChange={(e) =>
                                this.setState({ bairro: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                     
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-logradouro"
                            >
                              Logradouro
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-logradouro"
                              type="text"
                              required
                              maxLength="40"
                              value={this.state.logradouro}
                              onChange={(e) =>
                                this.setState({ logradouro: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>{" "}
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-numero"
                            >
                              Número
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="30"
                              value={this.state.numero}
                              onChange={(e) =>
                                this.setState({ numero: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-complemento"
                            >
                              Complemento
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="30"
                              value={this.state.complemento}
                              onChange={(e) =>
                                this.setState({ complemento: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Tratamento Biológico
                                </label>

                            <select
                              value={this.state.tratamento}
                              onChange={(e) =>
                                this.setState({
                                  tratamento: e.target.value,
                                })
                              }
                              className="form-control "
                              id="select-tratamento"
                            >
                              <option defaultValue="" value="">
                                {" "}
                                    Selecione...{" "}
                              </option>
                              <option value="true">
                                Sim
                                  </option>
                              <option value="false">Não</option>
                            </select>
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-numero"
                            >
                              Vol. Mínimo
                            </label>

                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-quarteirao"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 6);
                              }}
                              placeholder=""
                              value={this.state.volume_min}
                              onChange={(e) =>
                                this.setState({ volume_min: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-numero"
                            >
                              Vol. Máximo
                            </label>

                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-quarteirao"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 6);
                              }}
                              placeholder=""
                              value={this.state.volume_max}
                              onChange={(e) =>
                                this.setState({ volume_max: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <div className="text-center">
                      <Row>
                        <Col className="order-xl-1" xl="12">
                          {" "}
                          <Button
                            className="mt-4 btn-zoo-alt"
                            color="primary"
                            type="button"
                            onClick={this.handleSubmit}
                          >
                            <b>Pesquisar</b>
                          </Button>
                         
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.response && !this.state.requesting && (
           <Row className="text-left" style={{ paddingBottom:"2%" }}>
                        <Col className="order-xl-1" xl="12">

                <ExcelFile>
                <ExcelSheet data={this.state.response} name="Reservatórios">
                <ExcelColumn label="Código" 
                value={(row) => " "+row.id}
                cell={(props) => <span style={{ textAlign: 'left' }}>{props.value}</span>}
                 />
                
                  <ExcelColumn label="nome Imóvel" 
                value={(row) => " "+row.nome}
                cell={(props) => <span style={{ textAlign: 'left' }}>{props.value}</span>}
                 />
                
                 <ExcelColumn label="logradouro" 
                value={(row) => row.logradouro}
                cell={(props) => <span style={{ textAlign: 'left' }}>{props.value}</span>}
                 />
                 
                  <ExcelColumn label="bairro" 
                value={(row) => row.bairro ? row.bairro : ""}
                cell={(props) => <span style={{ textAlign: 'left' }}>{props.value}</span>}
                 />
                  <ExcelColumn label="Setor" 
                value={(row) => row.setor_nome ? row.setor_nome : ""}
                cell={(props) => <span style={{ textAlign: 'left' }}>{props.value}</span>}
                 />
                  <ExcelColumn label="volume" 
                value={(row) => row.volume ? " "+row.volume : ""}
                cell={(props) => <span style={{ textAlign: 'left' }}>{props.value}</span>}
                 />
                 <ExcelColumn label="Tratamento Biológico" 
                value={(row) => row.tratamento ? "Sim" : "Nâo"}
                cell={(props) => <span style={{ textAlign: 'left' }}>{props.value}</span>}
                 />
              
                
                 
                  
                  
                  
                 
                </ExcelSheet>
           
              </ExcelFile>
                        
                        </Col>
                      </Row>
                      )}
          {this.state.response && !this.state.requesting && (
            <DataTable
              noHeader={true}
              pagination={true}
              striped={true}
              columns={this.columns}
              responsive={true}
              highlightOnHover={true}
              data={this.state.response}
              paginationComponentOptions={this.defaultComponentOptions}
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
              customStyles={this.customStyles}
              progressPending={this.state.response === undefined}
              noDataComponent="Nenhum registro encontrado."
              paginationResetDefaultPage={this.state.response.length > 0}
            />
          )}
          {this.state.requesting && (
            <div className="text-center">
              <Spinner
                style={{ width: "3rem", height: "3rem" }}
                color="primary"
              />
            </div>
          )}
        </Container>
      </>
    );
  }
}
